module.exports = __webpack_public_path__ + "media/icons/sprowadzony-active@3x-65bb54c8.svg";